import { useEffect, useState } from "react";
import { stopBackground } from "./js/background";
import BlogPage from "./Pages/BlogPage/BlogPage";
import HomePage from "./Pages/HomePage/HomePage"

function App() {
  const [currentPage, setCurrentPage] = useState<boolean>(false)
  useEffect(() => {
    if (window.location.pathname === "/myblog") {
      setCurrentPage(true)
      stopBackground()
    }
  }, [])
  return (
    <div className="page">
      {
        currentPage ? <BlogPage/> :  <HomePage/>
      }
    </div>
  )
}

export default App;
